import { render, staticRenderFns } from "./Locals.vue?vue&type=template&id=78af4e8e&"
import script from "./Locals.vue?vue&type=script&lang=ts&"
export * from "./Locals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports